import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { filterChange, popUpMessageChange, signaturesUserChange, signaturesFilterChange } from '../../actions/index';

import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';

import { _ } from '../../functions/translator.js';
import { getRandomElement } from '../../functions/utils';
import { showMessage } from '../../functions/popUpMessage.js';

function UserSignsDropdown(props) {
    const [selectedUsers, setSelectedUsers] = useState([]);

    useEffect(() => {
        setSelectedUsers([]);
    }, [props.signaturesFilterHistoric]);

    const handleUserChange = (event) => {
        const userIds = event.target.value;
        setSelectedUsers(userIds);
        props.signaturesFilterChange(userIds);
        props.signaturesUserChange(userIds);
        if (userIds.length !== 0) {
            const message = _('Seleccione filtrar registros por') + ':';
            const messageConfig = {
                closeButton: true,
                signaturesFilterOption: true
            };
            showMessage(props, message, messageConfig);
        }
    };

    const useStyles = makeStyles((theme) => ({
        selected: {
            backgroundColor: '#3f51b5 !important',
            color: 'white',
        },
    }));
    const classes = useStyles();

    const usersList = Object.values(props.projectUsers).map((userData) => {
        const realUserName = `${userData.attributes.first_name} ${userData.attributes.last_name}`;
        const userName = window.is_demo ? getRandomElement(window.demo_user_names) : realUserName;
        const position = userData.attributes.position ? `- ${userData.attributes.position}` : '';
        return (
            <MenuItem key={userData.id} value={userData.id}>
                <Checkbox color="primary" checked={selectedUsers.includes(userData.id)} />
                {`${userName} ${position}`}
            </MenuItem>
        );
    });

    const userIdToName = Object.fromEntries(
        Object.values(props.projectUsers).map(userData => [
            userData.id,
            `${userData.attributes.first_name} ${userData.attributes.last_name} ${userData.attributes.position ? `- ${userData.attributes.position}` : ''}`
        ])
    );

    return (
        <div>
            <Select
                value={selectedUsers}
                onChange={handleUserChange}
                multiple
                renderValue={(selected) => (
                    <div>
                        {selected.map(id => userIdToName[id]).join(', ')}
                    </div>
                )}
                MenuProps={{
                    PaperProps: {
                        style: {
                          maxHeight: 300,
                          top: '0px',
                          position: 'fixed',
                        },
                    },
                    getContentAnchorEl: null,
                }}
            >
                {usersList}
            </Select>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        projectUsers: state.projectUsers,
        signaturesUserId: state.signaturesUserId,
        signaturesFilterHistoric: state.signaturesFilterHistoric,
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        filterChange: filterChange,
        popUpMessageChange: popUpMessageChange,
        signaturesUserChange: signaturesUserChange,
        signaturesFilterChange: signaturesFilterChange,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(UserSignsDropdown);
